/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React, { Component } from 'react';
import {
    object, shape, string, arrayOf, array, func, bool, number,
} from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Media from 'react-media';
import DeleteIcon from '@material-ui/icons/Delete';
import { compose } from 'recompose';
import ReactHtmlParser from 'react-html-parser';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import GraphqlModal from './Partials/GraphqlModal';
import { addToCartDataType, addonGroupsType } from '../common/types';
import AddonV2 from './AddonV2';
import AddOnDescription from './AddonV3/AddOnDescription';

const styles = (theme) => ({
    addonsProductContent: {
        color: theme.palette.black,
        paddingTop: '15px',
    },
    card: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        margin: '10px 0px 10px 0px',
        border: `1px solid ${theme.palette.grey8}`,
        '& .MuiCardContent-root': {
            padding: '10px',
            display: 'contents',
            [theme.breakpoints.up('md')]: {
                display: 'flex',
                minWidth: '100%',
            },
        },
        '@media only screen and (min-width: 601px) and (max-width: 850px)': {
            justifyContent: 'space-around',
        },
    },
    center: {
        textAlign: 'center',
    },
    centerImage: {
        margin: '0 auto',
    },
    addOnImageTeaser: { // TEMP Tablet presentation until Grid implementation
        '@media only screen and (min-width: 601px) and (max-width: 850px)': {
            '&:not(:nth-child(2))': {
                display: 'none',
            },
        },
    },
    cardContent: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'row',
        flexWrap: 'wrap',
        flexFlow: 'row wrap',
        alignContent: 'flex-end',
        padding: '0 12px',
    },
    cardHeading: {
        fontSize: '18px',
        fontWeight: '600',
        color: theme.palette.colorCardContent,
    },
    cardHeadingMobile: {
        fontSize: '12px',
        fontWeight: '600',
        color: theme.palette.colorCardContent,
    },
    imageContainer: {
        width: 'auto',
    },
    image: {
        float: 'left',
        width: '5.2vw',
        maxWidth: '80px',
        margin: '5px 6px 5px 0px',
    },
    cardInfoMobile: {
        fontSize: '12px',
        color: theme.palette.colorCardContent,
        margin: 0,
    },
    cardInfo: {
        fontSize: '15px',
        color: theme.palette.colorCardContent,
        margin: 0,
        float: 'left',
    },
    cardImg: {
        flex: '1 0 0',
        maxWidth: '112px',
        paddingRight: '12px',
    },
    cardDesc: {
        margin: '5px',
        maxWidth: '220px',
        minWidth: '194px',
        [theme.breakpoints.up('md')]: {
            margin: '0 auto',
        },
    },
    options: {
        fontSize: '13px',
        fontWeight: '700',
        textDecoration: 'underline',
        letterSpacing: '1px',
        textAlign: 'center',
        margin: 0,
        width: '35%',
        maxWidth: '130px',
        cursor: 'pointer',
        [theme.breakpoints.up('md')]: {
            width: 'auto',
            marginLeft: 'auto',
        },
    },
    addonList: {
        width: '644px',
        height: 'auto',
        marginTop: 15,
        marginBottom: 16,
        position: 'relative',
        fontFamily: theme.typography.fontFamily,
        color: theme.palette.black,
    },
    listHeader: {
        padding: '4px 14px',
        display: 'flex',
        justifyContent: 'space-between',
    },
    listTitle: {
        fontSize: 18,
        fontWeight: 600,
    },
    listItems: {
        width: '100%',
        display: 'flex',
        height: 30,
        padding: '0 6px',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    deleteIcon: {
        display: 'flex',
        alignItems: 'center',
    },
    price: {
        marginLeft: 35,
    },
    cardDetail: {
        width: '100%',
        padding: '15px',
    },
    mobileImage: {
        maxWidth: 140,
    },
    imageMobile: {
        width: 50,
        '&:last-child': {
            display: 'none',
        },
    },
    imageMobileSingle: {
        width: 100,
    },
    imageMobileDouble: {
        width: 50,
    },
    mobileDescription: {
        display: 'inline-block',
    },
    mobileAddonBox: {
        padding: 5,
    },
    mobileDescArrow: {
        width: '10%',
        display: 'inline-block',
        verticalAlign: 'super',
    },
    mobileDesc: {
        width: '90%',
        display: 'inline-block',
    },
    middle: {
        verticalAlign: 'middle',
    },
    centerButton: {
        margin: '10px auto',
    },
    itemRow: {
        verticalAlign: 'middle',
        alignItems: 'center',
        borderBottom: `1px solid ${theme.palette.grey8}`,
        textAlign: 'left',
        fontSize: 13,
    },
    delIcon: {
        fontSize: 22,
        cursor: 'pointer',
    },
    addonContainer: {
        display: 'flex',
        margin: '0px 40px 2px',
        boxShadow: 'none',
        [theme.breakpoints.down(1024)]: {
            margin: '0px 15px 2px',
        },
        '& .MuiCardContent-root': {
            display: 'flex',
            minWidth: '100%',
            padding: '26px  0px 25px',
            alignItems: 'flex-end',
            [theme.breakpoints.down(415)]: {
                padding: '17px  0px 16px',
            },
        },
        '& $centerImage': {
            margin: '0px',
        },
        '& $cardDesc': {
            margin: '0px',
            maxWidth: '100%',
            textAlign: 'left',
            marginLeft: '27px',
            [theme.breakpoints.down(1024)]: {
                marginLeft: '15px',
                maxWidth: '44%',
            },
            [theme.breakpoints.down(767)]: {
                marginLeft: '10px',
                maxWidth: '43%',
            },
        },
        '& $image': {
            margin: '0px 35px 0px 0px',
            maxWidth: '83px',
            [theme.breakpoints.down(1025)]: {
                margin: '0px 25px 0px 0px',
                width: '83px',
            },
            [theme.breakpoints.down(767)]: {
                margin: '0px 10px 0px 0px',
                width: '80px',
            },
        },
        '& $cardHeading': {
            fontWeight: 'bold',
            fontSize: '24px',
            lineHeight: '21px',
            display: 'flex',
            alignItems: 'center',
            height: '50px',
            letterSpacing: '0.05em',
            textTransform: 'capitalize',
        },
        '& $cardInfo': {
            fontWeight: 'normal',
            fontSize: '16px',
            lineHeight: '20px',
            display: 'flex',
            alignItems: 'center',
            height: '43px',
            [theme.breakpoints.down(767)]: {
                fontSize: '14px',
            },
        },
        '& $cardHeadingMobile': {
            fontSize: '18px',
            height: '25px',
            marginBottom: '9px',
            [theme.breakpoints.down(340)]: {
                marginBottom: '5px',
            },
        },
        '& $cardInfoMobile': {
            fontSize: '15px',
            height: '25px',
        },
        '& $centerButton': {
            fontWeight: 'bold',
            fontSize: '14px',
            lineHeight: '20px',
            display: 'flex',
            alignItems: 'center',
            margin: '0px 19px',
            letterSpacing: '0.1em',
            justifyContent: 'center',
            height: '43px',
        },
        '& $mobileImage': {
            maxWidth: '80px',
        },
        '& $imageMobile': {
            width: '100%',
        },
        '& $imageMobileSingle': {
            width: '100%',
        },
        '& $imageMobileDouble': {
            width: '50%',
        },
        '& $middle': {
            marginLeft: '19px',
            [theme.breakpoints.down(340)]: {
                marginLeft: '15px',
            },
        },
        '& $mobileContainer': {
            justifyContent: 'normal',
        },
        '& $mobileDescArrow': {
            width: '100%',
            bottom: '15px',
            position: 'absolute',
            right: '6px',
            display: 'block',
            textAlign: 'right',
        },
        '& $mobileAddonBox': {
            padding: '0px',
            position: 'relative',
        },
    },
    borderTop: {
        borderTop: 'solid 1px #7a7a7a',
    },
    mobileContainer: {

    },
});

class GraphqlAddon extends Component {
    constructor(props) {
        super(props);
        this.state = {
            openModal: false,
        };
    }

    openModal = () => {
        this.setState({ openModal: true });
    }

    closeModal = () => {
        this.setState({ openModal: false });
    }

    render() {
        const {
            classes,
            pageData,
            brand,
            product,
            skuData,
            handleAddonChange,
            handleAddonAdd,
            product: {
                brandId,
                partNumber,
            },
            categoryId,
            subscription,
            subscriptionDetails,
            presentation_family,
            disableAddToCart,
            isAddToCartEnabled,
            categoryPath,
            categoryName,
            selectedSku,
            productSkus,
            updateWineStatus,
            deliveryData,
            handleMiniCartModalClick,
            mobileAgeVerificationOpen,
            handleMobileAgeVerification,
            addToCartData,
            addonGroups,
            mixMatch,
            addonList,
            handleRemoveAddon,
            selectedAddons,
            pdpAddonV2,
            selectedMixMatchComponent,
            pdpInlineAddon,
            isPdpRedesignEnabled,
            content,
        } = this.props;
        const { openModal } = this.state;
        if (!pageData?.findContent?.content?.entries?.[0]) {
            return null;
        }
        const copy = pageData.findContent.content.entries[0].copy;
        const heading = pageData.findContent.content.entries[0].heading;
        const image = pageData.findContent.content.entries[0].images;
        const cardDescription = image?.length > 0 ? classes.cardDesc : classes.cardDetail;
        let imageDisplayCount;
        if (image.length === 1) {
            imageDisplayCount = classes.imageMobileSingle;
        } else if (image.length === 2) {
            imageDisplayCount = classes.imageMobileDouble;
        } else {
            imageDisplayCount = classes.imageMobile;
        }
        if (pdpInlineAddon) {
            return (
                <AddOnDescription
                    addonsData={addonGroups}
                    pdpInlineAddon={pdpInlineAddon}
                    brand={brand}
                    isPdpRedesignEnabled={isPdpRedesignEnabled}
                    content={content}
                />
            );
        }

        return (
            <div className={mixMatch ? `${classes.borderTop}` : ''}>
                {pdpAddonV2
                    ? <AddonV2 image={image} copy={copy} selectedSku={selectedSku} heading={heading} openModal={this.openModal} />
                    : (
                        <Card className={mixMatch ? `${classes.addonContainer}` : classes.card}>
                            <Media
                                query="(max-width: 600px)"
                            >
                                {(matches) => (
                                    matches ? (
                                        <CardContent className={classes.cardContent}>
                                            <div
                                                className={classes.mobileAddonBox}
                                                onClick={this.openModal}
                                                onKeyDown={() => { }}
                                                role="button"
                                                tabIndex={-1}
                                            >
                                                <Grid container className={classes.mobileContainer} alignItems="center" justify="space-between">
                                                    <Grid item xs={4} className={classes.mobileImage}>
                                                        {image?.map((img) => (
                                                            <img key={img.title} className={imageDisplayCount} src={img.url} alt={img.title} />
                                                        ))}
                                                    </Grid>
                                                    <Grid item xs={8} className={classes.middle}>
                                                        <div className={classes.mobileDesc}>
                                                            <div className={classes.cardHeadingMobile}>{heading}</div>
                                                            <p className={classes.cardInfoMobile}>{copy}</p>
                                                        </div>
                                                        <div className={classes.mobileDescArrow}>
                                                            <ArrowForwardIosIcon fontSize="small" />
                                                        </div>
                                                    </Grid>
                                                </Grid>
                                            </div>
                                        </CardContent>
                                    ) : (
                                        <CardContent className={mixMatch ? `${classes.center} ${classes.cardContent}` : classes.cardContent}>

                                            {image?.map((img) => (
                                                <div key={img.title} className={`${mixMatch ? `${classes.centerImage} ${classes.imageContainer}` : classes.imageContainer} ${classes.addOnImageTeaser}`}>
                                                    <img className={classes.image} src={img.url} alt={img.title} />
                                                </div>
                                            ))}
                                            <div className={mixMatch ? `${classes.center} ${cardDescription}` : cardDescription}>
                                                <div className={classes.cardHeading}>{heading}</div>
                                                <p className={classes.cardInfo}>{copy}</p>
                                            </div>
                                            <div
                                                className={mixMatch ? `${classes.centerButton} ${classes.options}` : classes.options}
                                                onClick={this.openModal}
                                                onKeyDown={() => { }}
                                                role="button"
                                                tabIndex={-1}
                                            >
                                                VIEW OPTIONS
                                            </div>
                                            {mixMatch && (
                                                <>
                                                    {addonList?.list?.map((item) => (
                                                        <Grid key={item.name} container className={classes.itemRow}>
                                                            <Grid item sm={8} xs={8}>{ReactHtmlParser(item.name)}</Grid>
                                                            <Grid item sm={2} xs={2}>{item.qty}</Grid>
                                                            <Grid item sm={2} xs={2}>
                                                                <DeleteIcon className={classes.delIcon} onClick={() => { handleRemoveAddon(item); }} />
                                                            </Grid>
                                                        </Grid>
                                                    ))}
                                                </>
                                            )}
                                        </CardContent>
                                    )
                                )}
                            </Media>
                        </Card>
                    )}
                {openModal
                    && (
                        <GraphqlModal
                            selectedAddons={selectedAddons}
                            brand={brand}
                            handleAddonChange={handleAddonChange}
                            handleAddonAdd={handleAddonAdd}
                            mixMatch={mixMatch}
                            product={product}
                            skuData={skuData}
                            typeModal="Addons"
                            titleModal="ADD SOMETHING SPECIAL"
                            onCloseModal={this.closeModal}
                            brandId={brandId}
                            partNumber={partNumber}
                            categoryId={categoryId}
                            subscription={subscription}
                            subscriptionDetails={subscriptionDetails}
                            presentation_family={presentation_family}
                            disableAddToCart={disableAddToCart}
                            isAddToCartEnabled={isAddToCartEnabled}
                            categoryPath={categoryPath}
                            categoryName={categoryName}
                            selectedSku={selectedSku}
                            productSkus={productSkus}
                            updateWineStatus={updateWineStatus}
                            deliveryData={deliveryData}
                            handleMiniCartModalClick={handleMiniCartModalClick}
                            mobileAgeVerificationOpen={mobileAgeVerificationOpen}
                            handleMobileAgeVerification={handleMobileAgeVerification}
                            addToCartData={addToCartData}
                            addonGroups={addonGroups}
                            selectedMixMatchComponent={selectedMixMatchComponent}
                        />
                    )}
            </div>
        );
    }
}
GraphqlAddon.propTypes = {
    classes: object.isRequired,
    handleMiniCartModalClick: func.isRequired,
    brand: shape({
        domain: string,
    }).isRequired,
    product: shape({
        id: string.isRequired,
        name: string.isRequired,
        brandId: string.isRequired,
        partNumber: string.isRequired,
    }).isRequired,
    skuData: arrayOf(
        shape({
            id: string.isRequired,
            name: string.isRequired,
            prices: arrayOf(
                shape({
                    type: string.isRequired,
                    value: number.isRequired,
                }),
            ).isRequired,
        }),
    ).isRequired,
    pageData: shape({
        findContent: shape({
            content: shape({
                entries: arrayOf(shape({
                    copy: string.isRequired,
                    heading: string.isRequired,
                    url: string,
                })),
            }),
        }),
    }).isRequired,
    selectedSku: shape({
        id: string.isRequired,
        minAge: string.isRequired,
    }).isRequired,
    productSkus: arrayOf(shape({
        minAge: string.isRequired,
    })).isRequired,
    handleAddonChange: func.isRequired,
    handleRemoveAddon: func,
    handleAddonAdd: func.isRequired,

    categoryId: string.isRequired,
    subscriptionDetails: shape({
        subscriptionType: string,
        subscriptionDuration: string,
        subscriptionFrequency: string,
    }),
    subscription: shape({
        subscriptionKey: array,
        subscriptionIndefinite: string,
        subscriptionType: array,
        implementProductSubscription: bool,
        viewSubscription: bool,
        isTypeDiscovery: bool,
    }),
    presentation_family: string.isRequired,
    disableAddToCart: bool,
    isAddToCartEnabled: bool,
    categoryPath: string.isRequired,
    categoryName: string.isRequired,
    deliveryData: shape({
        location_type_options: arrayOf(
            shape({
                name: string,
                value: string,
            }),
        ),
        show: bool,
        title: string,
        zip_code_title: string,
        location_type_title: string,
    }).isRequired,
    updateWineStatus: func.isRequired,
    mobileAgeVerificationOpen: bool,
    handleMobileAgeVerification: func,
    addToCartData: addToCartDataType,
    addonGroups: addonGroupsType.isRequired,
    mixMatch: bool,
    addonList: shape({
        list: arrayOf(shape({
            id: string,
            ageVerifyFlag: bool,
            partNumber: string,
            name: string,
        })),
    }),
    selectedAddons: arrayOf(shape({
        id: string,
        ageVerifyFlag: bool,
        partNumber: string,
        name: string,
    })),
    pdpAddonV2: bool,
    selectedMixMatchComponent: arrayOf(shape({
        brandCode: string,
        componentType: string,
        productId: string,
        productCode: string,
    })),
    pdpInlineAddon: bool,
    isPdpRedesignEnabled: bool,
    content: object.isRequired,
};

GraphqlAddon.defaultProps = {
    isAddToCartEnabled: true,
    selectedAddons: [],
    subscriptionDetails: {},
    disableAddToCart: false,
    subscription: {},
    mobileAgeVerificationOpen: false,
    handleMobileAgeVerification: () => { },
    addToCartData: {},
    mixMatch: false,
    addonList: {
        list: [],
    },
    selectedMixMatchComponent: [],
    handleRemoveAddon: () => {},
    pdpAddonV2: false,
    pdpInlineAddon: false,
    isPdpRedesignEnabled: false,

};

const enhance = compose(
    withStyles(styles),
);
export default enhance(GraphqlAddon);
